<template>
    <a-form-model :model="value" layout="inline" class="form-content">
        <a-row>
            <a-col :span="5">
                <a-form-model-item label="送货方式" :colon="false" class="form-item">
                    <a-select v-model="value.type" placeholder="请选择送货方式" @change="toSearch">
                        <a-select-option v-for="item in CARTYPE" :key="item.id">
                            {{ item.name }}
                        </a-select-option>
                    </a-select>
                </a-form-model-item>
            </a-col>
            <a-col :span="5">
                <a-form-model-item :label="value.type == '1' ? '出发地' : '始发仓'" :colon="false" class="form-item">
                    <a-input v-model="value.fromCity" class="w-224" placeholder="请输入" :max-length="100" @pressEnter="toSearch" />
                </a-form-model-item>
            </a-col>
            <a-col :span="5">
                <a-form-model-item :label="value.type == '1' ? '目的地' : '目的仓'" :colon="false" class="form-item">
                    <a-input v-model="value.desCity" class="w-224" placeholder="请输入" :max-length="50" @pressEnter="toSearch" />
                </a-form-model-item>
            </a-col>

            <a-col v-if="value.type !== '1'" :span="5">
                <a-form-model-item label="车型" :colon="false" class="form-item">
                    <a-select v-model="value.truckType" placeholder="请选择车型" allow-clear @change="toSearch">
                        <a-select-option v-for="item in CARTYPELIST" :key="item.id">
                            {{ item.name }}
                        </a-select-option>
                    </a-select>
                </a-form-model-item>
            </a-col>

            <a-col :span="4" class="form-btns">
                <a-button class="reset-btn" @click="onReset">重置</a-button>
                <a-button type="primary" @click="toSearch">
                    查询
                </a-button>
            </a-col>
        </a-row>
    </a-form-model>
</template>

<script>
import { CARTYPELIST, CARTYPE } from '../const';

export default {
    name: 'LineSearch',
    model: {
        prop: 'value',
        event: 'change'
    },
    props: {
        value: {
            type: Object,
            default: () => {}
        }
    },
    data() {
        return {
            CARTYPELIST,
            CARTYPE
        };
    },
    methods: {
        toSearch() {
            this.$emit('toSearch');
        },
        onReset() {
            this.$emit('onReset');
        }
    }
};
</script>
<style lang="less" scoped>
.form-content {
    .form-btns {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        height: 40px;
        .reset-btn {
            margin-right: 8px;
        }
    }
    .form-item {
        width: 100%;
        /deep/.ant-form-item-control-wrapper {
            width: calc(100% - 102px);
            margin-right: 32px;
        }
    }
}
</style>
